import {
  createSlice,
  createDraftSafeSelector,
  createSelector,
} from "@reduxjs/toolkit";
import { addItemsToCart, decreaseCartItems } from "utils/cart/cartUtils";

const initialState = {
  hidden: true,
  cartItems: [],
  totalPrice: "",
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    toggleCart: (state, action) => {
      state.hidden = !state.hidden;
    },
    openCart: (state, action) => {
      state.hidden = false;
    },
    hideCart: (state, action) => {
      state.hidden = true;
    },
    addToCart: (state, action) => {
      // state.cartItems = [...state.cartItems, action.payload]
      state.cartItems = addItemsToCart(state.cartItems, action.payload);
    },
    removeFromCart: (state, action) => {
      state.cartItems = state.cartItems.filter(
        (cartItem) => cartItem.id !== action.payload
      );
    },
    decreaseItems: (state, action) => {
      state.cartItems = decreaseCartItems(state.cartItems, action.payload);
    },
  },
});

const { reducer, actions } = cartSlice;
export const {
  toggleCart,
  openCart,
  hideCart,
  addToCart,
  removeFromCart,
  decreaseItems,
} = actions;
export default reducer;

const selectCart = (state) => state.cart;

export const selectCartHidden = createSelector(
  [selectCart],
  (cartHidden) => cartHidden.hidden
);

export const selectCartItems = createSelector(
  [selectCart],
  (cart) => cart.cartItems
);

export const cartItemsCount = createSelector([selectCartItems], (items) =>
  items.reduce((amount, { quantity }) => amount + quantity, 0)
);

export const selectTotalPrice = createSelector(
  [selectCartItems],
  (totalPrice) =>
    totalPrice
      ?.map((TotalPrice) => TotalPrice.quantity * TotalPrice.price)
      ?.reduce((prev, price) => prev + price, 0)
);
